import environment from '../../../common/environment';
import { getResponseData } from '../../../common/utils/api-utils';

const APIS = {
    clickthrough: `${environment().searchV2Api}/clickthrough`
}

export interface IElasticAnalyticsAPI {
    postElasticAnalyticsClickthrough(requestBody: any);
}

export class ElasticAnalyticsAPI implements IElasticAnalyticsAPI {
    async postElasticAnalyticsClickthrough(requestBody: any) {
      return getResponseData(
        new Request(new URL(APIS.clickthrough), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        })
      );
    }
}

export const elasticAnalyticsAPI = new ElasticAnalyticsAPI();